import type { PlanFeatures } from "@/shared/types/planFeatures";

export type ContentFeatureAvailability = { polls: boolean, surveys: boolean };

/** Surveys take precedence over Polls, independently of user permissions. */
export const getContentFeatureAvailability = (features?: Partial<PlanFeatures>): ContentFeatureAvailability => {
  const surveys = !!features?.service_surveys;
  return { polls: !!features?.service_polls && !surveys, surveys };
};

export const isEffectiveFeatureEnabled = (key: keyof PlanFeatures, features?: Partial<PlanFeatures>): boolean => {
  const availability = getContentFeatureAvailability(features);
  if (key === "service_polls") return availability.polls;
  if (key === "service_surveys") return availability.surveys;
  return !!features?.[key];
};

/** Stable identifiers used by web menus, banners and mobile destinations. */
export const isContentFeatureAvailable = (key: string, availability: ContentFeatureAvailability): boolean => {
  if (["poll", "polls", "sondages", "service_polls"].includes(key)) return availability.polls;
  if (["survey", "surveys", "enquetes", "service_surveys"].includes(key)) return availability.surveys;
  return true;
};
